import React from "react";
import './index.scss';
import { useLocation, useNavigate } from "react-router-dom";
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import IconButton from "@mui/material/IconButton";
import CustomBadge from "../Badge";
import GroupOffOutline from "../Icons/GroupOff";
import GroupOutline from "../Icons/Group";

const MyDocumentControls = ({ docId, restrictedToTravellerIds, isEditable }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const restrictedCount =
    Array.isArray(restrictedToTravellerIds) && restrictedToTravellerIds.length > 0
      ? restrictedToTravellerIds.length - 1
      : null;

  const renderIconButton = side => {
    const isLeft = side === "left";

    const icon = isLeft
      ? restrictedToTravellerIds?.length === 1 ? <GroupOffOutline /> : <GroupOutline />
      : isEditable ? <TuneOutlinedIcon /> : <GroupOutline />;

    const handleNavigate = (e) => {
      if (!isEditable) return;

      e.stopPropagation();
      navigate(`${location.pathname}/document_settings/${docId}`);
    };

    return (
      <IconButton
        className="white-icon-button"
        aria-label={isLeft ? "personalisation" : "control"}
        sx={{
          cursor: isEditable ? 'pointer' : 'default',
        }}
        disableFocusRipple={!isEditable}
        disableRipple={!isEditable}
        tabIndex={!isEditable ? -1 : 0}
        onClick={(e) => handleNavigate(e)}
        onKeyDown={(e) => e.key === 'Enter' && handleNavigate(e)}
      >
        {icon}
      </IconButton>
    )
  };

  return (
    <div className="my-document-buttons"
         onClick={(e) => {
           e.stopPropagation()
         }}
    >
      <CustomBadge badgeContent={restrictedCount}>
        {isEditable && renderIconButton("left")}
      </CustomBadge>
      <div className="vertical-separator"></div>
      {renderIconButton("right")}
    </div>
  )
};

export default MyDocumentControls;